import "./index.css";

export const Loader: React.FC = () => {
  return <span className="loader"></span>;
};
